import styled from "styled-components";
import { colors } from "../../../../../../../theme/theme";

export const ContentHeader = styled.div`
    color: ${colors.greyscale.darker_grey};
    font-size: 16px;
    border-bottom: 1px solid  ${colors.greyscale.light_grey};

    .title{
        font-size: 26px;
    }

    .subtitle{
        font-size: 14px;
        padding-left: 15px;
    }
`

export const ContentBody = styled.div`
    color: ${colors.greyscale.darker_grey};
    font-size: 16px;
`